import { ArrowRight, Play, Camera, Film, Mic } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../../context/LanguageContext';

const ContentShowcase = () => {
  const { t } = useLanguage();

  const contentTypes = [
    { icon: Film, title: t('content.types.documentaries.title'), desc: t('content.types.documentaries.desc') },
    { icon: Camera, title: t('content.types.fashion.title'), desc: t('content.types.fashion.desc') },
    { icon: Mic, title: t('content.types.social.title'), desc: t('content.types.social.desc') },
    { icon: Play, title: t('content.types.brand.title'), desc: t('content.types.brand.desc') }
  ];

  return (
    <section id="content" className="py-20 bg-[#313131] text-white relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5" 
           style={{
             backgroundImage: `radial-gradient(circle at 3px 3px, rgba(179, 209, 48, 0.8) 2px, transparent 0)`,
             backgroundSize: '60px 60px'
           }}>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-6xl font-bold mb-8">
            {t('content.title')}
            <span className="block text-[#b3d130]">{t('content.titleHighlight')}</span>
          </h2>
          <p className="text-xl text-gray-300 max-w-4xl mx-auto leading-relaxed">
            {t('content.description')}
          </p>
        </div>

        {/* Content Types Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16">
          {contentTypes.map((type, index) => (
            <div key={index} className="group text-center">
              <div className="w-20 h-20 bg-[#b3d130] rounded-full flex items-center justify-center mx-auto mb-6 group-hover:bg-white group-hover:text-[#313131] transition-all duration-300 transform group-hover:scale-110">
                <type.icon size={32} />
              </div>
              <h3 className="text-xl font-bold mb-3 group-hover:text-[#b3d130] transition-colors duration-300">
                {type.title}
              </h3>
              <p className="text-gray-400 group-hover:text-gray-300 transition-colors duration-300">
                {type.desc}
              </p>
            </div>
          ))}
        </div>

        {/* Video Showcase */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
          {[1, 2, 3].map((item) => (
            <div key={item} className="group relative bg-gradient-to-br from-gray-700 to-gray-800 rounded-3xl overflow-hidden aspect-video hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2">
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent"></div>
              <div className="absolute inset-0 flex items-center justify-center">
                <div className="w-16 h-16 bg-[#b3d130] rounded-full flex items-center justify-center group-hover:scale-110 transition-transform duration-300 cursor-pointer">
                  <Play className="text-[#313131] ml-1" size={24} />
                </div>
              </div>
              <div className="absolute bottom-6 left-6 right-6">
                <h4 className="text-white font-semibold mb-2">{t('content.project')} {item}</h4>
                <p className="text-gray-300 text-sm">{t('content.projectDescription')}</p>
              </div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center">
          <Link to="/content" className="group bg-[#b3d130] text-[#313131] px-8 py-4 rounded-full font-semibold text-lg hover:bg-white transition-all duration-300 transform hover:scale-105 flex items-center mx-auto">
            {t('content.discover')}
            <ArrowRight size={20} className="ml-2 group-hover:translate-x-1 transition-transform duration-300" />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default ContentShowcase;